import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        padding: '20px 15px',
        backgroundColor: '#212121',
        color: 'white',
        textAlign: 'center',
        marginTop: 'auto',
      }}
    >
      {/* First Row: Name and Bar */}
      <Box sx={{ marginBottom: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Typography variant="body2" sx={{fontSize:{xs:"9px", md:"14px"}, opacity: 0.7 , marginRight: '8px' }}>
          {t('footer.name')}
        </Typography>
        <Typography variant="body2" sx={{ marginRight: '8px' }}>|</Typography>
        <Typography variant="body2" sx={{fontSize:{xs:"9px", md:"14px"}, opacity: 0.7 }}>
          {t('footer.location')}
        </Typography>
      </Box>

      {/* Second Row: Creating Message */}
      <Box sx={{ marginBottom: '10px' }}>
        <Typography variant="body2" sx={{fontSize:{xs:"9px", md:"14px"}, fontStyle: 'italic', opacity: 0.8 }}>
          {t('footer.message')}
        </Typography>
      </Box>

      {/* Third Row: Copyright */}
      <Box>
        <Typography variant="body2" sx={{fontSize:{xs:"9px", md:"14px"}, opacity: 0.7 }}>
          {t('footer.copyright')}
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
